module.exports = __webpack_public_path__ + "img/117.8f6e6692.jpg";